// extracted by css-extract-rspack-plugin
export default {"host":"BurstHeart-module__host"};